__turbopack_context__.v({
  "className": "geist_mono_cd63f48-module__xsvO6a__className",
  "variable": "geist_mono_cd63f48-module__xsvO6a__variable",
});
